export function convertDateToLocalTime(dateToConvert) {
    var timezoneOffset = new Date().getTimezoneOffset() * 60 * 1000;
    var localMillisecondsMinusOffset = dateToConvert.getTime() - timezoneOffset;
    var localTimestamp = new Date(localMillisecondsMinusOffset).toUTCString();
    return localTimestamp;
}
